/**
 * @description Pushes an event to the Google Tag Manager data layer.
 * @param event - The event object to be pushed to the data layer.
 * @returns void
 */
export const pushToDataLayer = (event: Record<string, any>) => {
  if (typeof window === 'undefined') return;
  if (!window.dataLayer) {
    window.dataLayer = [];
  }
  window.dataLayer.push(event);
};
